const REQUIRED_KEYS = ["apiUrl", "supabaseUrl", "supabasePublishableKey"];
const REQUIRED_BY_TARGET = {
  site: [...REQUIRED_KEYS, "appUrl"],
  app: REQUIRED_KEYS,
  store: REQUIRED_KEYS,
};
const DEV_ENVIRONMENTS = new Set(["development", "dev", "test", "local"]);
import { getFrontendTarget } from "./frontendTarget";

const clean = (value) => String(value || "").trim().replace(/\/$/, "");

function isLoopback(hostname) {
  const host = String(hostname || "").replace(/^\[|\]$/g, "").toLowerCase();
  return host === "localhost" || host === "127.0.0.1" || host === "::1";
}

export function validateMcpUrl(value, environment = "production") {
  const raw = clean(value);
  if (!raw) return "";
  let parsed;
  try { parsed = new URL(raw); } catch { throw new Error("URL MCP inválida"); }
  if (!/^https?:$/.test(parsed.protocol) || parsed.username || parsed.password || parsed.search || parsed.hash) {
    throw new Error("URL MCP inválida");
  }
  if (parsed.protocol === "http:" && !(DEV_ENVIRONMENTS.has(String(environment).toLowerCase()) && isLoopback(parsed.hostname))) {
    throw new Error("URLs MCP remotas exigem HTTPS");
  }
  return parsed.toString().replace(/\/$/, "");
}

export function validateRuntimeConfig(input) {
  const frontendTarget = getFrontendTarget(input?.frontendTarget || process.env.REACT_APP_FRONTEND_TARGET || "app");
  const config = {
    apiUrl: clean(input?.apiUrl),
    supabaseUrl: clean(input?.supabaseUrl),
    supabasePublishableKey: clean(input?.supabasePublishableKey),
    appUrl: clean(input?.appUrl),
    mcpUrl: validateMcpUrl(input?.mcpUrl, input?.environment || "production"),
    environment: clean(input?.environment) || "production",
    frontendTarget,
  };
  const missing = REQUIRED_BY_TARGET[frontendTarget].filter((key) => !config[key]);
  if (missing.length) throw new Error(`runtime config ausente: ${missing.join(", ")}`);
  return config;
}

function injectedConfig() {
  return typeof window !== "undefined" ? window.__RUNTIME_CONFIG__ : undefined;
}

export function getRuntimeConfig() {
  const injected = injectedConfig();
  if (injected) return validateRuntimeConfig(injected);
  if (process.env.NODE_ENV !== "production") {
    const devConfig = {
      apiUrl: process.env.REACT_APP_BACKEND_URL,
      supabaseUrl: process.env.REACT_APP_SUPABASE_URL,
      supabasePublishableKey: process.env.REACT_APP_SUPABASE_ANON_KEY,
      mcpUrl: process.env.REACT_APP_MCP_URL,
      environment: process.env.REACT_APP_APP_ENV || "development",
      frontendTarget: process.env.REACT_APP_FRONTEND_TARGET || "app",
    };
    if (REQUIRED_KEYS.every((key) => devConfig[key])) return validateRuntimeConfig(devConfig);
  }
  throw new Error("runtime config indisponível; configure /runtime-config.js antes de iniciar a aplicação");
}

export async function loadRuntimeConfig() {
  try {
    return getRuntimeConfig();
  } catch (error) {
    if (typeof document === "undefined") throw error;
    await new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.src = `/runtime-config.js?ts=${Date.now()}`;
      script.async = false;
      script.onload = resolve;
      script.onerror = () => reject(new Error("runtime config não pôde ser carregado"));
      document.head.appendChild(script);
    });
    return getRuntimeConfig();
  }
}

